const saveToLocalStorage = (key, value) => {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.error(`Error saving ${key} to localStorage:`, error);
    }
};

const getFromLocalStorage = (key, defaultValue = null) => {
    try {
        const storedValue = localStorage.getItem(key);
        return storedValue ? JSON.parse(storedValue) : defaultValue;
    } catch (error) {
        console.error(`Error reading ${key} from localStorage:`, error);
        return defaultValue;
    }
};

export const setStoreObj = (storeObj) => saveToLocalStorage('storeObj', storeObj);
export const getStoreObj = () => getFromLocalStorage('storeObj', null);
export const setDeliveryMethod = (deliveryMethod) => saveToLocalStorage('deliveryMethod', deliveryMethod);
export const getDeliveryMethod = () => getFromLocalStorage('deliveryMethod', null);
export const setPaymentMethod = (paymentMethod) => saveToLocalStorage('paymentMethod', paymentMethod);
export const getPaymentMethod = () => getFromLocalStorage('paymentMethod', null);
export const setOrderStatus = (orderStatus) => saveToLocalStorage('orderStatus', orderStatus);
export const getOrderStatus = () => getFromLocalStorage('orderStatus', 'not-started');
export const setTotalPrice = (totalPrice) => saveToLocalStorage('totalPrice', totalPrice);
export const getTotalPrice = () => getFromLocalStorage('totalPrice', 0);